// extracted by mini-css-extract-plugin
module.exports = {"avatarPlaceholder":"Avatar_avatarPlaceholder__ixn1z","avatar":"Avatar_avatar__Bv9y3"};